<div class="wrapper">
    @if (vm().isLoading) {
        <div class="skeleton-wrapper">
            <ng-container [ngTemplateOutlet]="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    } @else {
        <p class="label-2 uppercase">{{ brand() }}</p>
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    }
</div>

<ng-template #content>
    @if (vm().isNameTemplate) {
        <ng-container [ngTemplateOutlet]="vm().nameTemplate"></ng-container>
    } @else {
        <h3 class="heading-3">{{ vm().name }}</h3>
    }
</ng-template>
